import styled, { css } from 'styled-components';
const lgSizeMixin = css `
  @apply h-12 pl-4;
`;
export const Container = styled.div `
  @apply relative w-full h-7 box-border inline-flex items-center overflow-visible rounded-md p-0.5 pl-1 justify-start;
  border: 1px solid var(--border-color);
  background-color: var(--active-bg-color);
  border-color: ${(props) => (props.focus ? 'transparent' : 'var(--border-color)')};

  div.input-effect {
    @apply absolute top-0 left-0 w-full h-full rounded-md pointer-events-none origin-center;
    box-shadow: ${(props) => (props.focus ? '0 0 0 3px var(--focus-border-color)' : 'none')};
  }

  input {
    @apply appearance-none border-none shadow-none p-0 bg-transparent box-border outline-none w-full leading-4;
    color: var(--text-color-0);
    text-indent: 2px;

    &::placeholder {
      color: var(--text-color-2);
    }
  }

  [data-role='input-icon'] {
    @apply inline-flex items-center justify-center w-6 h-6;

    color: var(--text-color-2);
    --ggs: 0.75;
  }

  ${(props) => {
    if (props.size === 'lg') {
        return lgSizeMixin;
    }
}}
`;
